
<template>
  <div class="home-main">
    <Row :gutter="40">
      <Col span="12">
        <h2>代办事项</h2>
      <Card :padding=30 dis-hover>
        <div class="h-todo">
          <b>18</b>
          <p>
            <span>周四</span>
            <label>这是一句特别励志的话</label>
          </p>
          <Button type="primary" shape="circle" icon="ios-add" class="right"></Button>
        </div>
        <article class="h-todo2">
          这是一句特别励志的话这是一句特别励志的话,这是一句特别励志的话是一句特别励志的话
        </article>
        <h6 class="h-todo3">提醒事项：</h6>
        <p>这是一句特别励志的话这是一句特别,励志的话这是,一句特别,励志的话这是一句特别励志的话这是一句特别励志的话</p>
      </Card>
      </Col>
      <Col span="12">
          <h2>通知预警</h2>
          <section>
            <label>筛选条件：</label>
            <Select v-model="d_notice" class="h-notice1" disabled>
              <Option value="重要等级">重要等级</Option>
              <Option value="姓名">姓名</Option>
              <Option value="店铺">店铺</Option>
              <Option value="状态">状态</Option>
            </Select>
            <article class="notice-group">
              <div v-if="d_data_notice.length>0">
                <p v-for="(item,index) in d_data_notice" :key="index">
                  <span v-if="item.State==='未处理'">{{item.Reason}}</span>
                  <!--<Button type="error" class="right" size="small" @click="to_delete(item.ID)">删除</Button>-->
                  <Button v-if="item.State==='未处理'" size="small" class="right" @click="to_handle(item.ID,'已处理');">处理</Button>
                </p>
              </div>
              <div class="empty-notice" v-else>
                <Icon size="50" type="logo-playstation" />
                <span>暂无通知预警数据</span>
              </div>
            </article>
          </section>
      </Col>
    </Row>
    <br>
    <br>
    <h2>统计</h2>
    <Row class="h-statistics text-center">
      <Col span="12">
        <Icon type="ios-albums" size="100"/>
        <p>显示出租率和空置率</p>
        <h6>出租情况</h6>
      </Col>
      <Col span="12">
        <Icon type="logo-buffer" size="100"/>
        <p>当年的含税收入，应缴税款，不含税收入</p>
        <h6>收入情况</h6>
      </Col>
    </Row>
  </div>
</template>

<script>
  import apiNotice from '@/api/notice.js';
export default {
  name: 'home',
  data () {
    return{
      d_notice:'重要等级',
      single:false,
      d_data_notice:[]
    }
  },
  methods:{
    pull_data() {
      let _this = this;
      let params = {
        PageIndex: 1,
        PageSize: 5
      };
      apiNotice.getList.post(params).then((_data) => {
        if(_data.data.ExeSuccess && _data.data.LoginSuccess){
          let requestResult = _data.data.Data;
          let rowsList = requestResult.RowsList;
          _this.d_data_notice = rowsList;
        }else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    to_handle(_id,_state){
      apiNotice.setState(_id,_state).then((_data) => {
        if(_data.data.ExeSuccess && _data.data.LoginSuccess){
          this.$Message.success('状态修改成功');
          this.pull_data();
        }else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    to_delete(_id){
      apiNotice.del(_id).then((_data) => {
        if(_data.data.ExeSuccess && _data.data.LoginSuccess){
          this.$Message.success('删除成功');
          this.pull_data();
        }else {
          this.$Message.error(_data.data.Msg);
        }
      });
    }
  },
  created() {
    this.pull_data();
  }
}
</script>

<style lang="less">
.count-style{
  font-size: 50px;
}
</style>
<style lang="less" scoped>
  *{ font-size: 14px; }
  h2{ font-size: 20px;margin-bottom: 20px; }
  .notice-group{
    margin-top: 40px;
    font-size: 13px;
    p{ margin-bottom: 20px; }
    .Checkbox{ margin-right: 20px; }
    .ivu-btn{
      float: right;
      font-size: 12px;
      margin-left: 10px;
    }
    .empty-notice{
      padding-top: 40px;
      text-align: center;
      color:#c5c8ce;
      .ivu-icon{ color:#c5c8ce; }
      span{ display: block;text-align: center;margin-top: 30px; }
    }
  }
  .h-todo{
    margin-bottom: 20px;
    b{ display: inline-block;font-size: 38px;margin-right: 20px; }
    p{ display: inline-block;
      label{ display: block }
    }
    .ivu-btn{ margin-top: 10px; }
  }
  .home-main{ padding:10px 20px; }
  .h-todo2{ margin-bottom: 20px; }
  .h-todo3{ margin-bottom: 10px;font-size: 15px;font-weight: normal;color: #ff9900; }
  .h-notice1{ width:200px;margin-left: 10px; }
  .h-statistics{
    p{ margin: 20px 0; }
    h6{ font-size: 16px; }
  }
</style>
